import { ApdmCampaignKind, ApdmCampaignMode } from '@euler/model/apdm';
import { ReviewChoice, ReviewField } from '../../imports/ReviewControls';
import { WizardFormProps } from './WizardControls';
export const wizardKindOptions = [
  { value: ApdmCampaignKind.WinBack, label: '唤回客户' },
  { value: ApdmCampaignKind.MaintenanceDue, label: '保养提醒' },
  { value: ApdmCampaignKind.Promotion, label: '优惠活动' },
  { value: ApdmCampaignKind.Greeting, label: '节日问候' },
];
export const wizardModeOptions = [
  { value: ApdmCampaignMode.OneShot, label: '一次性' },
  { value: ApdmCampaignMode.Ongoing, label: '持续进行' },
];
export function WizardBasics({
  draft,
  disabled,
  onChange,
  identityFrozen,
}: WizardFormProps & { identityFrozen: boolean }) {
  return (
    <>
      <ReviewField
        label="活动名称"
        value={draft.title}
        disabled={disabled}
        onChange={title => onChange({ ...draft, title })}
      />
      <ReviewChoice
        label="活动类型（更改并保存后重置人群规则与提醒策略）"
        options={wizardKindOptions}
        value={draft.kind}
        disabled={disabled || identityFrozen}
        onChange={kind => onChange({ ...draft, kind })}
      />
      <ReviewChoice
        label="活动模式"
        options={wizardModeOptions}
        value={draft.mode}
        disabled={disabled || identityFrozen}
        onChange={mode => onChange({ ...draft, mode })}
      />
    </>
  );
}
